import { render, staticRenderFns } from "./TokenDepositsHistoryTable.vue?vue&type=template&id=7bb3f3ca"
import script from "./TokenDepositsHistoryTable.vue?vue&type=script&lang=js"
export * from "./TokenDepositsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports